module.exports = __webpack_public_path__ + "media/images/no-decks-graphic-868b480b.svg";